export default __webpack_public_path__ + "static/media/Score Appears.37e0146b.mp3";